// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { FaShareAlt, FaArrowLeft } from "react-icons/fa";
// import { ArrowLeftOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";

// const previewContainerStyle = {
//   width: "365px",
//   minHeight: "557px",
//   maxHeight: "667px",
//   margin: "10px auto",
//   border: "1px solid #ccc",
//   borderRadius: "20px",
//   overflow: "hidden",
//   boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//   backgroundColor: "#f8f9fa",
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "space-between",
//   paddingBottom: 20,
// };

// const headerStyle = {
//   backgroundColor: "#fff",
//   height: 100,
//   borderRadius: 0,
//   boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//   display: "flex",
//   alignItems: "center",
//   paddingLeft: 15,
//   color: "rgb(14, 57, 114)",
//   fontWeight: "bold",
//   fontSize: 23,
// };

// const backButtonStyle = {
//   cursor: "pointer",
//   display: "flex",
//   alignItems: "center",
//   color: "rgb(14, 57, 114)",
//   fontSize: 25,
//   marginRight: 10,
// };

// const scrollContainerStyle = {
//   overflowY: "auto",
//   flexGrow: 1,
//   padding: "10px 15px",
// };

// const imageCardStyle = {
//   boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
//   borderRadius: 4,
//   marginBottom: 10,
//   cursor: "pointer",
// };

// const fullImageContainerStyle = {
//   textAlign: "center",
//   paddingTop: 20,
// };

// const fullImageStyle = {
//   width: "100%",
//   maxHeight: 400,
//   objectFit: "contain",
//   borderRadius: 10,
// };

// const shareButtonStyle = {
//   marginTop: 20,
//   fontSize: 30,
//   cursor: "pointer",
//   color: "rgb(14, 57, 114)",
// };

// function GalleryWeb() {
//   const [images, setImages] = useState([]);
//   const [fullPhoto, setFullPhoto] = useState(null);
// const navigate = useNavigate();
//   const dist = sessionStorage.getItem("dist") || "320E";

//   useEffect(() => {
//     const getImages = async () => {
//       try {
//         const res = await axios.get(
//           "https://lionsdirectoryapi.emedha.in/gallery/api/gallery/approved",
//           { params: { dist } }
//         );
//         setImages(res.data);
//       } catch (error) {
//         console.error("Error fetching images:", error);
//       }
//     };

  //   getImages();
  // }, [dist]);

//   // Web share fallback - shares URL only, no local file
//   const shareImage = async () => {
//     if (navigator.share) {
//       try {
//         await navigator.share({
//           title: "Check out this image!",
//           url: fullPhoto,
//         });
//       } catch (err) {
//         alert("Sharing failed: " + err.message);
//       }
//     } else {
//       alert("Sharing not supported on this browser.");
//     }
//   };

//   return (
//     <div style={previewContainerStyle}>
//        <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Gallery</h6>
//       </div>
//     </div>

//       {!fullPhoto ? (
//         <div style={scrollContainerStyle}>
//           {images.map((img) => (
//             <div
//               style={imageCardStyle}
//               key={img.image}
//               onClick={() => setFullPhoto(img.image)}
//             >
//               <img
//                 src={img.image}
//                 alt="Gallery"
//                 style={{ width: "100%", height: 200, borderRadius: 4, objectFit: "cover" }}
//               />
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div style={fullImageContainerStyle}>
//           <img
//             src={fullPhoto}
//             alt="Full view"
//             style={fullImageStyle}
//             onClick={() => setFullPhoto(null)}
//           />
//           <div>
//             <FaShareAlt
//               style={shareButtonStyle}
//               onClick={shareImage}
//               title="Share Image"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default GalleryWeb;


import React, { useEffect, useState } from 'react';
import { ChevronLeft, Filter } from 'lucide-react';
import axios from 'axios';

const ActivityGallery = ({ onBack, onSelectImage, styles }) => {

    const [images, setImages] = useState([]);
  const [fullPhoto, setFullPhoto] = useState(null);

  const dist = sessionStorage.getItem("dist") || "320E";

  useEffect(() => {
    const getImages = async () => {
      try {
        const res = await axios.get(
          "https://lionsdirectoryapi.emedha.in/gallery/api/gallery/approved",
          { params: { dist } }
        );
        setImages(res.data);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    getImages();
  }, [dist]);

  console.log("setImages",images)

  return (
    <div style={styles.scrollArea}>
      <div style={{ backgroundColor: '#0033A0', padding: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: 'white' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
          <h2 style={{ fontSize: '18px', margin: 0 }}>Activity Gallery</h2>
        </div>
        <Filter size={20} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', padding: '15px' }}>
        {images.map((photo) => (
          <div 
            key={photo.id} 
            onClick={() => onSelectImage(photo)}
            style={{ position: 'relative', borderRadius: '15px', overflow: 'hidden', height: '180px', cursor: 'pointer' }}
          >
            <img src={photo.image} alt="Activity" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            {/* Date Badge */}
            <div style={{ position: 'absolute', top: '8px', left: '8px', backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', padding: '2px 8px', borderRadius: '4px', fontSize: '10px' }}>
              {new Date(photo.created_at).toLocaleDateString("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "short",
  year: "numeric",
})}
            </div>
            {/* Club Name Label */}
            <div style={{ position: 'absolute', bottom: '8px', width: '100%', textAlign: 'center', color: 'white', fontSize: '11px', fontWeight: 'bold', textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>
              {photo.club_name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityGallery